import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { FtoReportInputLanguageDetectionService } from '../input-language-detection-service';
import { SupportedLanguages } from '../../constants';
import { ToastError } from '@telecom/shared/utils/toast-error';
import { I18nService } from '@telecom/shared/services/i18n';
import { FtoReportInputLanguageDetectApi } from '../../apis/novelty-input-language-detect-api';

@injectable()
export class FtoServiceInputLanguageDetectionServiceImpl implements FtoReportInputLanguageDetectionService {

    constructor(
        @inject(FtoReportInputLanguageDetectApi)
        private _noveltyInputLanguageDetectApi: FtoReportInputLanguageDetectApi,
        @inject(I18nService)
        private _i18nService: I18nService,
    ) {}

    async detect(input: string): Promise<boolean> {
        const result = await this._detectRepository(input);
        return Promise.resolve(result);
    }

    private async _detectRepository(input: string) {
        const result = await this._noveltyInputLanguageDetectApi.detect({
            input,
        });
        const language = result.toLowerCase();
        if (!SupportedLanguages.includes(language)) {
            const errorMessage = this._i18nService.t('fto.errors.inputLanguageDetectFailed');
            throw new ToastError(errorMessage);
        }
        return true;
    }
}
